<template>
  <div
    class="selection-card"
    :class="{ 'selection-card--is-selected': isSelected}"
    tabindex="0"
    v-bind="ariaAttributes"
    @click="handleClick"
    @keypress.enter="handleClick"
    @keypress.space.prevent="handleClick"
  >
    <slot />
    <KIcon name="check" aria-hidden="true" v-if="isSelected" class="selection-card__icon-check w-4 md:w-6 absolute" />
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue'
import KIcon from '@/components/atoms/Icon/index.vue'

export default defineComponent({
  name: 'SelectionCard',
  components: { KIcon },
  emits: ['select'],
  props: {
    value: {
      type: [Object, String, Number],
      required: true
    },
    isSelected: {
      type: Boolean,
      default: false
    },
    independent: {
      type: Boolean,
      default: false
    }
  },
  setup (props, { emit }) {
    const ariaAttributes = computed(() =>
      props.independent
        ? null
        : {
          role: 'option',
          'aria-selected': props.isSelected
        }
    )

    const handleClick = () => {
      emit('select', props.value, !props.isSelected)
    }

    return {
      ariaAttributes,
      handleClick
    }
  }
})
</script>

<style scoped>

[aria-selected="true"]::after {
  content: " (selected)";
  clip-path: inset(0);
  clip: rect(0 0 0 0);
  height: 1px;
  width: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
}

.selection-card {
  min-height: 232px;
  transition: border var(--transition-speed) var(--transition-timing-function);
  @apply cursor-pointer relative border-2 rounded-lg border-gray-base bg-gray-base;

  &:focus {
    @apply outline-none;
  }
  body:not(.using-mouse) &:focus {
    @apply border-black-darkest;
  }
  &:hover,
  &--is-selected {
     @apply border-primary; 
   
  }
  &__icon-check {
    top: theme('spacing.4');
    right: theme('spacing.4');
  }
}

@screen md {
  .selection-card {
    min-height: 336px;
    flex-grow: 0;
    flex-shrink: 0;
    width: 235px;
  }
}
</style>
